import { Injectable } from '@angular/core';
import { Language } from '@app/models';
import { TranslateService } from '@ngx-translate/core';
import { PrimeNGConfig } from 'primeng/api';
import { map } from 'rxjs';
import { GenericObject } from '../utils';

export const PrimeNGTranslationKey = [
  'PRIMENG.dayNamesMin',
  'PRIMENG.dayNames',
  'PRIMENG.dayNamesShort',
  'PRIMENG.monthNames',
  'PRIMENG.monthNamesShort',
  'PRIMENG.dateFormat',
  'PRIMENG.emptyMessage',
  'PRIMENG.emptyFilterMessage',
];

@Injectable({ providedIn: 'root' })
export class SettingsService {
  constructor(private translate: TranslateService, private config: PrimeNGConfig) {}

  loadLanguage(language: Language) {
    return this.translate.use(`${language.languageCode}-${language.countryCode}`).pipe(
      map(() => {
        this.translate.get(PrimeNGTranslationKey).subscribe((res: string | any) => {
          const newData = Object.keys(res).reduce((acc, val) => ((acc[val.replace('PRIMENG.', '')] = res[val]), acc), {} as GenericObject);

          this.config.setTranslation(newData);
        });
      })
    );
  }
}
